import {useEffect, useRef} from "react";
import useFetch from "v4/hooks/useFetch";
import useNotification from "v4/hooks/useNotification";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

/**
 * @param {Function} updateHandler - reçoit `(file, 'remove')` au succès dans la vue show, appelé sans argument dans les listings
 */
export default function useDeletePdf(updateHandler) {
    const {t} = usePolTranslation();
    const {addSuccessNotification} = useNotification();
    const [{
        isLoading: isLoadingDelete,
        isError: isErrorDelete,
        isFinished: isFinishedDelete
    }, fetchDelete] = useFetch();
    const deletingFileRef = useRef(null);

    const deletePdf = (file) => {
        if (!file?.deleteLink) return;

        deletingFileRef.current = file;
        fetchDelete({
            url: file.deleteLink,
            config: {method: 'DELETE'}
        });
    };

    useEffect(() => {
        if (isFinishedDelete && !isErrorDelete && deletingFileRef.current) {
            updateHandler(deletingFileRef.current, 'remove');
            addSuccessNotification(t('pdf_deleted'));
            deletingFileRef.current = null;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFinishedDelete, isErrorDelete]);

    return {
        deletePdf,
        isLoadingDelete,
        isErrorDelete,
        isFinishedDelete,
    };
}
